import { connect } from 'react-redux'
import Settings from 'modules/Settings/index'
import selectors from 'modules/Settings/selectors'
import {
  getInstituteInfo,
  updateInstituteInfos,
} from 'modules/Settings/actions'
import authSelector from 'modules/Auth/selectors'
import {
  getListOfCities,
  getListOfCountries,
  getListOfStates,
  getUserRoles,
} from 'modules/Auth/actions'
const mapStateToProps = state => ({
  instituteData: selectors.getInstituteData(state),
  listOfStates: authSelector.getListOfStates(state),
  listOfCities: authSelector.getListOfCities(state),
  userRoles: authSelector?.getUserRoleList(state),
  permissions : authSelector?.getUserPermissions(state)
})

const mapDispatchToProps = {
  getInstituteInfo,
  getListOfCities,
  getListOfCountries,
  getListOfStates,
  getUserRoles,
  updateInstituteInfos,
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
